import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import Success from '@assets/images/Success.svg';
import './SuccessModal.scss';

interface SuccessModalProps {
    visible: boolean;
    title: string;
    message: string;
    onClose: () => void;
    modalStyle?: React.CSSProperties;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ visible, title, message, onClose, modalStyle }) => {
    // Custom footer style to make button full width
    const customFooterStyle = {
        paddingTop: '8px',
        marginTop: '-8px',
        minHeight: '64px',
        justifyContent: 'center' as const,
    };

    return (
        <Modal
            visible={visible}
            title={''}
            ariaLabel={title}
            onCancel={onClose}
            modalStyle={modalStyle || { width: '500px' }}
            footerStyle={customFooterStyle}
            className="success-modal"
            header={''}
            icons={''}
            footer={
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Button style={{ width: '100%' }} onClick={onClose} kind="primary">
                        Close
                    </Button>
                </div>
            }>
            <div className="success-modal-content">
                <Success />
                <div className="ap-typography-heading-m ap-mt-spacing-6">{title}</div>
                <div className="ap-typography-body ap-mt-spacing-4">{message}</div>
            </div>
        </Modal>
    );
};

export default SuccessModal;
